//葡萄牙语
export default {
    login1: 'Já tem conta? ',
    login2: 'Ir para login',
    login3: 'Redefinir palavra-passe? ',
    login4: 'Comece a usar o 51shopy',
    login5: 'Esqueceu-se da palavra-passe?',
    login6: 'Registe-se agora',
    login7: 'E-mail',
    login8: 'Código de verificação',
    login9: 'Introduza o código de verificação',
    login10: 'password',
    login11: 'Confirmar palavra-passe',
    login12: 'Por favor, introduza novamente a sua palavra-passe',
    login13: 'Registar',
    login14: 'Próximo passo',
    login15: 'Enviar',
    login16: 'Enviar código de verificação',
    login17: 'Por favor, introduza o endereço de e-mail e o código de verificação corretos! ',
    login18: 'As palavras-passe que introduziu duas vezes não correspondem!',
    login19: 'O código de verificação foi enviado',
    login20: 'O endereço de e-mail não pode estar vazio',
    login21: 'O formato do e-mail está incorreto',
    login22: 'O código de verificação não pode estar vazio',
    login23: 'O comprimento do código de verificação é de 4 caracteres',
    login24: 'A palavra-passe não pode estar vazia',
    login25: 'O comprimento da palavra-passe não pode ser inferior a 6 caracteres',
    login26: 'Password alterada com sucesso! ',
    login27: 'Registo realizado com sucesso! ',
    login28: 'Login bem-sucedido',
    login29: 'O nome da conta não pode estar vazio',
    login30: 'Faça login na sua conta abaixo para começar',
    login31: 'Conta',
    login32: 'Clique para efetuar login',
    login33: "Compre produtos de qualidade e ganhe bónus",
    login34: "Registe-se para desfrutar de um presente maravilhoso",
    login35: "Entrar",
    login36: "Registar",
    home1: 'Popular',
    home2: 'Tem a certeza de que quer sair? ',
    home3: 'Prompt',
    home4: 'OK',
    home5: 'Cancelar',
    home6: 'Fãs',
    home7: 'Seguir',
    home8: 'Centro Pessoal',
    home9: 'Comprei',
    home10: 'Eu vendi',
    home11: 'A minha carteira',
    home12: 'Sair',
    home13: 'Total',
    home14: 'itens',
    home15: 'Povoado',
    home16: 'Preço acessível',
    home17: 'Logística rápida',
    home18: 'Garantia de Qualidade',
    home19: 'Sobre nós',
    home20: 'Central de Ajuda',
    home21: 'Serviço pós-venda',
    home22: 'Entrega e aceitação',
    home23: 'Cooperação Empresarial',
    home24: 'Recomendações de investigação',
    home25: 'Links amigáveis',
    home26: 'Seguir',
    home27: 'Já preocupado',
    home28: 'Compre já',
    home29: 'Adicionar ao carrinho',
    home30: 'Recolhido com sucesso! ',
    home31: 'Cancelar recolha com sucesso! ',
    home32: 'Tem a certeza de que quer deixar de seguir?',
    home33: 'Cancelado com sucesso! ',
    home34: 'Siga o Sucesso! ',
    home35: 'O conteúdo não pode estar vazio',
    home36: 'Comentário bem-sucedido!',
    home37: 'Avaliações de produtos',
    home38: 'Avalie já',
    home39: 'Avaliação',
    home40: 'História',
    home41: 'Deixar de seguir com sucesso! ',
    home42: 'Este tipo é muito misterioso e não tem biografia. ',
    home43: 'Início',
    number1: 'A Minha Conta',
    number2: 'Centro Pessoal',
    number3: 'Carteira',
    number4: 'Favoritos',
    number5: 'Seguir',
    number6: 'Seguidores',
    number7: 'Histórico de navegação',
    number8: 'Gestão de transações',
    number9: 'Eu publiquei',
    number10: 'eu comprei',
    number11: 'Eu vendi',
    number12: 'Carrinho',
    number13: 'Página pessoal',
    number14: 'Atendimento ao Cliente',
    number15: 'Definições',
    number16: 'Adicionar endereço',
    number17: 'Modificar morada',
    number18: 'Apenas os ficheiros de imagem podem ser enviados!',
    number19: 'O tamanho do ficheiro não pode exceder 10 MB!',
    number20: 'Imagem carregada com sucesso',
    number21: 'Equilíbrio',
    number22: 'Recolher itens',
    number23: 'Informações pessoais',
    number24: 'Editar',
    number25: 'Enviar',
    number26: 'Apelido',
    number27: 'Perfil pessoal',
    number28: 'endereço de entrega',
    number29: 'Adicionar',
    number30: 'Padrão',
    number31: 'Não pago',
    number32: 'Aguarda entrega',
    number33: 'Concluído',
    number34: 'Cancelado',
    number35: 'Revisão pendente',
    number36: 'Aprovado',
    number37: 'Rejeitado',
    number38: 'Encomenda concluída',
    number39: 'Pagamento do pedido efectuado com sucesso!',
    number40: 'Encomenda cancelada com sucesso! ',
    number41: 'Retirada bem-sucedida! ',
    number42: 'Recarregar',
    number43: 'Retirar',
    number44: 'Histórico de Consumo',
    number45: 'Número do pedido',
    number46: 'nome do pagamento',
    number47: 'Todos',
    number48: 'Consulta',
    number49: 'Número do pedido',
    number50: 'nome do pagamento',
    number51: '51 moedas',
    number52: 'Estado do pedido',
    number53: 'Hora de criação do pedido',
    number54: 'Hora de atualização do pedido',
    number55: 'Operação',
    number56: 'Pago',
    number57: 'Cancelar encomenda',
    number58: 'Detalhes',
    number59: 'Número',
    number60: 'enviado',
    number61: 'pendente',
    number62: 'Registo de levantamento',
    number63: 'user id',
    number64: 'Valor de levantamento',
    number65: 'Estado',
    number66: 'Hora da criação',
    number67: 'Retirar da carteira',
    number68: 'Retirar',
    number69: 'Detalhes do pedido de carteira',
    number70: 'Todos os pedidos',
    number71: 'Pagamento pendente',
    number72: 'Aguarda entrega',
    number73: 'Concluído',
    number74: 'Cancelado',
    number75: 'Pago',
    number76: 'Todas as remessas',
    number77: 'Número do pedido de logística',
    number78: 'Envio realizado com sucesso!',
    number79: 'Vendi',
    number80: 'Ainda não há dados do pedido',
    number81: 'Número do pedido',
    number82: 'Hora do pedido',
    number83: 'Pessoa do pedido',
    number84: 'Alterar hora',
    number85: 'Detalhes',
    number86: 'Total',
    number87: 'enviado',
    number88: 'Detalhes',
    number89: 'Preencher o número do pedido de logística',
    number90: 'Número do pedido de logística',
    number91: 'Por favor, introduza o número do pedido de logística',
    number92: 'Cancelado com sucesso!',
    number93: 'Sucesso! ',
    number94: 'Entrega atrasada da encomenda realizada com sucesso!',
    number95: 'Comprei',
    number96: 'Pague agora',
    number97: 'Confirmar receção',
    number98: 'Entrega atrasada',
    number99: 'Cancelar encomenda',
    number100: 'Utilizador Vendedor',
    number101: 'A minha coleção',
    number102: 'Os meus fãs',
    number103: 'Os Meus Seguidores',
    number104: 'nome do pagamento',
    number105: '51 moedas',
    number106: 'Estado do pedido',
    number107: 'Tempo de pagamento',
    number108: 'Eu paguei',
    number109: 'Pagamento do pedido efetuado com sucesso! ',
    number110: 'Todos os produtos',
    number111: 'Tem a certeza de que pretende eliminar o produto?',
    number112: 'Apagado com sucesso! ',
    number113: 'Cancelado com sucesso! ',
    number114: 'Tem a certeza de que pretende colocar o produto na prateleira?',
    number115: 'Tem a certeza de que pretende remover o produto?',
    number116: 'Sucesso! ',
    number117: 'Na prateleira',
    number118: 'pronto a usar',
    number119: 'Apagar',
    number120: 'Ver detalhes',
    cart1: 'Informações do produto',
    cart2: 'preço unitário',
    cart3: 'Quantidade',
    cart4: 'Subtotal',
    cart5: 'operação',
    cart6: 'preço unitário',
    cart7: 'Tem a certeza de que pretende eliminar?',
    cart8: 'Confirmar',
    cart9: 'Cancelar',
    cart10: 'apagar',
    cart11: 'A lista do carrinho de compras está vazia',
    cart12: 'itens, total de itens',
    cart13: 'Total',
    cart14: 'Acordo',
    cart15: 'Adicionar endereço',

    cart16: 'Um dos telegram e watchApp deve ser preenchido',
    cart17: 'Configuração de informação do utilizador bem-sucedida!',
    cart18: 'Selecione ou preencha o endereço de entrega! ',
    cart19: 'Encomenda criada com sucesso! ',
    cart20: 'endereço de entrega',
    cart21: 'Precisa de adicionar um endereço de entrega antes de enviar o pedido. ',
    cart22: 'Consignatário',
    cart23: 'Informações de contacto',
    cart24: 'endereço de entrega',
    cart25: 'Alterar morada',
    cart26: 'Adicionar endereço',
    cart27: 'Informações do produto',
    cart28: 'Preço unitário',
    cart29: 'Quantidade',
    cart30: 'Pagamento real',
    cart31: 'Preço total',
    cart32: 'Detalhes do valor',
    cart33: 'Valor total a pagar',
    cart34: 'Submeter',
    cart35: 'Alterar morada de entrega',
    cart36: 'Cancelar',
    cart37: 'OK',
    cart38: 'Informações do utilizador',
    cart39: 'Enviar',
    cart40: 'O apelido não pode estar vazio',
    cart41: 'Nome não pode estar vazio',
    cart42: 'O número de telemóvel não pode estar vazio',
    cart43: 'O país não pode estar vazio',
    cart44: 'Província/Município/Distrito não pode estar vazio',
    cart45: 'A cidade não pode estar vazia',
    cart46: 'O endereço detalhado não pode estar vazio',
    cart47: 'O código postal não pode estar vazio',
    cart48: 'Endereço modificado com sucesso! ',
    cart49: 'Endereço adicionado com sucesso! ',
    cart50: 'apelido',
    cart51: 'nome',
    cart52: 'País',
    cart53: 'Província/Concelho/Região',
    cart54: 'cidade',
    cart55: 'Endereço detalhado',
    cart56: 'Código postal',
    cart57: 'Número de telefone de contacto',
    cart58: 'É padrão',
    cart59: 'Início',
    cart60: 'Atendimento ao Cliente',
    cart61: 'Publicar',
    cart62: 'Meu',
    cart63: 'Carrinho',
    cart64: 'Tempo de envio',
    cart65: 'Hora do pagamento',
    cart66: 'Informações de entrega',
    cart67: 'Pagamento real',
    cart68: 'Enviar para',
    cart69: 'Produtos',
    cart70: 'Pode solicitar fatura',
    cart71: 'Informações do pedido',
    cart72: 'Comerciante',
    cart73: 'Envio bem sucedido! ',
    cart74: 'Cópia bem-sucedida',
    cart75: 'Falha na cópia',
    cart76: 'proporção',
    cart77: 'Limite de crédito',
    cart78: 'Transferir',
    cart79: 'Valor da recarga',
    cart80: 'Recarregar',
    cart81: 'Classificação',
    setup1: 'Informações pessoais',
    setup2: 'O meu endereço de entrega',
    setup3: 'O Meu Perfil',
    setup4: 'Conta e Segurança',
    setup5: 'Privacidade',
    setup6: 'Geral',
    setup7: 'Ajuda e Feedback',
    setup8: 'Sobre nós',
    setup9: 'Sair',
    setup10: 'Mensagem da estação',
    setup11: 'Ainda não há dados',
    setup12: 'Adicionado ao carrinho com sucesso!',
    setup13: 'Falha ao adicionar ao carrinho!',

    setup14: 'Edição de produto',
    setup15: 'Lançamento do produto',
    setup16: 'Imagem da capa do produto',
    setup17: 'Categoria do produto',
    setup18: 'Nome do produto',
    setup19: 'Preço do produto (CNY)',
    setup20: 'Descrição do produto',
    setup21: 'Fotos do produto (Máx. 10 imagens)',
    setup22: 'Reiniciar',
    setup23: 'Produto criado com sucesso! ',
    setup24: 'Stock insuficiente do produto! ',
    setup25: 'Método de pagamento',
    setup26: '51coin',
    setup27: 'transferir',
    setup28: 'Link do produto ou link do nome/artigo',
    setup29: 'O utilizador não é um vendedor e não pode publicar produtos! ',
    setup30: 'Operação não humana detectada! ',
    setup31: 'Inventário de produtos',
    setup32: 'Visualizações',
    setup33: 'Encomenda enviada com sucesso! ',
    setup34: 'Exibir ordem',
    setup35: 'Inventário de produtos',
    setup36: 'Categoria de produto não pode estar vazia',
    setup37: 'O nome do produto não pode estar vazio',
    setup38: 'A descrição do produto não pode estar vazia',
    setup39: 'O stock do produto não pode estar vazio',
    setup40: 'O preço do produto não pode estar vazio',
    setup41: 'A imagem da capa não pode estar vazia',
    setup42: 'A imagem do produto não pode estar vazia',
    setup43: 'A transferência foi feita e está a aguardar confirmação',
    setup44: 'Selecione o método de transferência! ',
    setup45: 'Tempo de conclusão',
    setup46: 'Moeda 51',
    setup47: 'Pagto. Transf.',
    setup48: 'Método de transferência',
    setup49: "Detalhes do produto",
    setup50: "Comprador",
    setup51: "O custo de envio do produto é",
    setup52: "Taxa de envio",
    setup53: "Quantidade de vendas",
    setup54: "Quantidade mínima de compra",
    setup55: "Adicionar endereço",
    setup56: "A conta foi recebida",
    setup57: "Informações de contacto do beneficiário",
    setup58: "Informações de contacto do comerciante",
    setup59: "Informações de contacto do comprador",
    setup60: "Copiar",
    setup61: "Populares",
    setup62: "Preencha pelo menos um campo",
    setup63: "Contacte-nos",
    setup64: "Estimativa de envio",
    setup65: "Assine-nos",
    setup66: "Cooperação de celebridades da Internet no estrangeiro",
    setup67: "Problemas de pagamento e pós-venda",
    setup68: "Dividendos do utilizador",

    setup69: "Tipo de moeda",
    setup70: "Taxa de câmbio",
    setup71: "Taxa de manuseamento",
    setup72: "Recibo real",
    setup73: "Valor mínimo de levantamento",
    setup74: "Moeda",
    setup75: "Taxa de manuseamento",
    setup76: "Recibo real",

    setup78: "Código de convite",
    setup79: "Por favor, introduza o código de convite",
    setup80: "O código de área do telemóvel não pode estar vazio",
    setup81: "Código de área",
    setup82: "Cancelar hora",
    setup83: "Detalhes de retirada",
    setup84: "Detalhes do dividendo",
    setup85: "Está expirado?",
    setup86: "Se deve usar",
    setup87: "Não expirado",
    setup88: "Expirado",
    setup89: "Não utilizado",
    setup90: "Já usado",
    setup91: "Parcialmente utilizado",
    setup92: "reembolso",
    setup93: "Reembolso utilizado",
    setup94: "Reembolso remanescente",
    setup95: "Se deve usar",
    setup96: "Está expirado?",
    setup97: "Tempo de expiração",
    setup98: "Hora do desconto",
    setup99: "Partilha de Aliança",
    setup100: "Cancelar pagamento",
    setup101: "Fechar a interface",
    setup102: "Pagamento USDT",
    setup103: "Valor pago",
    setup104: "Valor da transação da encomenda",
    setup105: "Rede",
    setup106: "Paga-se pela rede",
    setup107: "Pagamento bem-sucedido",
    setup108: "Morada da carteira do beneficiário",
    setup109: "Por favor, verifique cuidadosamente se o valor real do pagamento é consistente com o valor que transferiu. Se houver algum erro, será você mesmo a suportar as consequências",
    setup110: "Tempo de expiração",
    setup111: "Aguarda pagamento",
    setup112: "Pagamento bem-sucedido",
    setup113: "Pedido expirado",
    setup114: "Verificar transações blockchain",
    setup115: "",
    setup116: "",
    setup117: "",
    setup118: "",
    setup119: "",

    setup130: "Sobre nós",
    setup131: "Relacionado com a entrega",
    setup132: "Outro",
    setup133: "Política de Envio",
    setup134: "Horário de entrega/levantamento do pacote",
    setup135: "Termos de Serviço",
    setup136: "Método de pagamento",
    setup137: "Política de devolução",
    setup138: "Política de Privacidade",
    setup139: "Space Network Technology Co., Ltd.",
    setup140: "Horário de trabalho:",
    setup141: "Pessoa de contacto:",
    setup142: "E-mail da empresa:",
    setup143: "Código Postal:",
    setup144: "Morada: ",

    setup0140: "Segunda a sexta-feira (9:00-18:00)",
    setup0141: "Sr. Liang",
    setup0143: "999077",
    setup0144: "Sala 341, 3º andar, Edifício Industrial Público, 56 Hoi Yuen Road, Kwun Tong, Hong Kong",

    setup145: "Contrato de Envio Internacional de Pacotes",
    setup146: "Devido à particularidade do transporte internacional, é necessário cumprir as regras de transporte internacional de encomendas. Leia atentamente e aceite os seguintes termos e condições.",
    setup147: "Padrão de compensação de pacotes:",
    setup148: "Se os seus produtos forem perdidos, extraviados, danificados, atrasados ​​ou retidos pela alfândega durante o transporte devido a razões fora do controlo da 51shopy, a 51shopy não será responsável por indemnizações. Também não assumimos qualquer responsabilidade por perdas indiretas de lucro não realizadas. Para detalhes reais, consulte 'Seguro e Compensação de Pacotes'.",
    setup149: "A 51shopy não é responsável por indemnização nos seguintes casos (para pacotes não segurados):",
    setup150: "1. Não será dada qualquer compensação por perdas de correspondência causadas por força maior, tais como desastres naturais ou motivos alfandegários;",
    setup151: "2. Se os artigos enviados violarem proibições ou restrições, as autoridades competentes confiscarão ou tratarão deles de acordo com as leis e regulamentos relevantes, sem compensação;",
    setup152: "3. Ao enviar uma encomenda, se a encomenda estiver embalada em boas condições, não apresentar sinais de desmontagem e não tiver perdido peso, mas as peças internas estiverem em falta ou danificadas, não será dada qualquer compensação;",
    setup153: "4. Se o rastreio do correio mostrar que o pacote não foi entregue normalmente e a empresa de logística confirmar que o pacote foi confiscado pela alfândega, a investigação da empresa de logística prevalecerá e não será dada qualquer compensação;",
    setup154: "5. Não será dada qualquer compensação se o e-mail for perdido ou o conteúdo estiver em falta devido a falha do cliente ou do próprio e-mail;",
    setup155: "6. Se o cliente não fizer uma consulta e não apresentar uma reclamação a partir da data de entrega do e-mail até ao fim do período de consulta, não será fornecida qualquer compensação;",
    setup156: "7. Se o correio internacional for retido, confiscado ou destruído pelo país de destino de acordo com as suas leis nacionais, não será fornecida qualquer compensação.",
    setup157: "Artigos Proibidos",
    setup158: "Cumpra as regulamentações do nosso país sobre artigos proibidos e restritos:",
    setup159: "1. Cumprir o anúncio do Departamento de Correios do Estado, do Ministério da Segurança Pública e do Ministério da Segurança do Estado sobre a emissão do 'Regulamento sobre a Gestão de Artigos Proibidos'.",
    setup160: "2. Cumprir as disposições da Ordem nº 43 da Administração Geral das Alfândegas (Lista de Artigos Proibidos e Restritos para Importação e Exportação da República Popular da China).",
    setup161: "Artigos que não podem ser enviados pelo correio",
    setup162: "1. Artigos cuja circulação e transporte são proibidos de acordo com as leis nacionais.",
    setup163: "2. Mercadorias perigosas explosivas, inflamáveis, corrosivas, radioativas ou tóxicas.",
    setup164: "3. Publicações, livros, materiais ou artigos que contenham conteúdo reaccionário ou obsceno.",
    setup165: "4. Várias moedas.",
    setup166: "5. Artigos que violam a saúde pública.",
    setup167: "6. Artigos perecíveis.",
    setup168: "7. Animais vivos (exceto abelhas, bichos-da-seda e sanguessugas, desde que a embalagem garanta a segurança dos trabalhadores).",
    setup169: "8. A embalagem inadequada pode representar um risco para os trabalhadores ou contaminar ou danificar outros artigos embalados.",
    setup170: "9. Outros artigos não adequados para envio.",
    setup171: "Artigos proibidos de entrega de acordo com a prática postal",
    setup172: "1. Artigos cuja qualidade ou embalagem possam causar danos aos funcionários dos correios ou contaminar/danificar outras embalagens ou equipamentos postais.",
    setup173: "2. Artigos com selos de metal ou outras arestas afiadas que possam interferir com o processamento postal.",
    setup174: "3. Vários tipos de armas de fogo, munições, explosivos, inflamáveis, corrosivos, materiais ou recipientes radioativos, venenos fortes, drogas estupefacientes, produtos bioquímicos e materiais infeciosos.",
    setup175: "4. Quaisquer publicações, materiais de propaganda ou materiais impressos que possam pôr em perigo a segurança social e a estabilidade ou que contenham conteúdos obscenos.",
    setup176: "5. Vários itens que podem colocar em risco a saúde pública.",
    setup177: "6. Documentos ou artigos que não são aceites ou autorizados a circular no país recetor.",
    setup178: "Métodos de pagamento disponíveis",
    setup179: "O site suporta vários métodos de pagamento, incluindo cartões de crédito/débito, WeChat, Alipay, etc. Se precisar de fazer pagamentos frequentes ou deduções de custódia, também pode utilizar o saldo para pagar.",
    setup180: " - Se ocorrer um reembolso para um pedido de compra com cartão de crédito/débito, este será reembolsado para a conta original; o reembolso para a recarga de saldo será também reembolsado para a conta original",
    setup181: " - Se ocorrer um reembolso para pagamentos de encomendas efetuados através do WeChat, Alipay, etc., o reembolso será devolvido à conta original;",
    setup182: "- Se ocorrer um reembolso para o pagamento do saldo, este será reembolsado para o saldo da conta;",
    setup183: "Política de Privacidade do Utilizador 51shopy",
    setup184: "A segurança das suas informações pessoais é muito importante para nós, e valorizamos a sua confiança. Em nenhuma circunstância venderemos ou divulgaremos as suas informações pessoais a terceiros. Protegeremos a segurança e a privacidade de quaisquer informações pessoais que nos forneça e utilizaremos as informações apenas conforme descrito aqui. Se tiver alguma dúvida, sugestão ou comentário sobre esta Política de Privacidade, pode contactar-nos a qualquer momento, visitando o sistema de atendimento ao cliente online da 51shopy ou a conta de serviço oficial da 51shopy.",
    setup185: "Esta política não se aplica a serviços que lhe são fornecidos por terceiros, nem se aplica a serviços para os quais definimos políticas de privacidade de forma independente.",
    setup186: "Leia e compreenda esta política cuidadosamente antes de utilizar os serviços da 51shopy. A sua concordância com esta política de privacidade significa que compreendeu as funções fornecidas por esta aplicação e as informações pessoais necessárias para executar as funções.",
    setup187: "Os direitos de propriedade e de funcionamento dos serviços de utilizador registados relevantes pertencem à ",
    setup188: "1. Que informações pessoais recolhemos?",
    setup189: "Pode optar por utilizar ou visitar o nosso website sem revelar qualquer informação pessoal e de transação sobre si, mas precisa de registar uma conta para experimentar o nosso serviço completo. Se nos fornecer as suas informações, concorda com a transferência e armazenamento das informações nos nossos servidores.",
    setup190: "A 51shopy recolhe informações pessoais que fornece quando utiliza o website, que incluem o seu nome, informações de contacto, endereço de e-mail, nome de conta 51shopy e palavra-passe, e outras informações necessárias para que possa criar uma conta. Para além das informações pessoais que podemos recolher e processar durante o registo, também recolhemos, armazenamos e processamos as seguintes informações sobre os nossos utilizadores na 51shopy:",
    setup191: "1) Informação de compra",
    setup192: "2) Informação da conta de serviço",
    setup193: "3) Informação de pagamento (hora do pagamento, valor do pagamento, canal de pagamento, etc.)",
    setup194: "4) Pesquisar informação do histórico de navegação (conteúdo da pesquisa, comportamento de clique em ligação, histórico de navegação, histórico de visualização de cliques, etc.)",
    setup195: "5) Cookies e outras informações do computador",
    setup196: "Estabelecemos uma parceria com a Microsoft Clarity e a Microsoft Advertising para captar a forma como utiliza e interage com o nosso website através de métricas comportamentais, mapas de calor e repetições de sessão para melhorar e comercializar os nossos produtos/serviços. Os dados de utilização do website são captados utilizando cookies primários e de terceiros e outras tecnologias de rastreio para determinar a popularidade dos produtos/serviços e atividades online. Além disso, utilizamos estas informações para otimização do website, fins de fraude/segurança e publicidade. Para obter mais informações sobre a forma dados, visite",
    setup197: "Declaração de Privacidade da Microsoft",
    setup198: "2. Como utilizamos as suas informações pessoais?",
    setup199: "Não venderemos ou divulgaremos qualquer informação pessoal do utilizador e esforçar-nos-emos por proteger as suas informações e privacidade. Utilizaremos as suas informações para lhe fornecer melhores serviços, incluindo:",
    setup200: "1) Contactá-lo por e-mail e fornecer uma série dos nossos serviços, incluindo serviços de consultoria, serviços de informação de encomendas, serviços de informação de pacotes, serviços pós-venda de produtos, etc.",
    setup201: "2) Comunicar-lhe as atividades da plataforma por e-mail, correio interno, etc., incluindo o fornecimento de cupões, descontos de envio e promoções especiais, bem como oportunidades de utilizar serviços de terceiros.",
    setup202: "3) Quando pesquisa e navega pelos links dos nossos comerciantes parceiros no 51shopy, o seu ID de utilizador do 51shopy, comportamentos de operação relacionados e informações (conteúdo de pesquisa, comportamento de clique em links, histórico de navegação, histórico de visualização de cliques, etc.) serão fornecidos à fonte do link de comportamento de operação, para que nós e os nossos comerciantes parceiros possamos trabalhar em conjunto para lhe fornecer serviços eficientes e de alta qualidade. Pode clicar para visualizar os comerciantes parceiros do 51shopy .com, www.1688.com).",
    setup203: "De acordo com as leis, regulamentos e normas nacionais, nas seguintes circunstâncias, os parceiros não necessitam da sua autorização ou consentimento para utilizar, transferir ou divulgar as suas informações pessoais:",
    setup204: "1) De acordo com os requisitos obrigatórios das leis, regulamentos, órgãos administrativos e judiciais e outras obrigações legais;",
    setup205: "2) Na medida do permitido pelas leis e regulamentos, é necessário salvaguardar o interesse público, a segurança da propriedade e proteger-se a si ou a outros utilizadores do 51shopy, o 51shopy, afiliados ou parceiros do 51shopy contra danos;",
    setup206: "3) Necessário para desempenhar as funções principais dos nossos produtos e/ou serviços, ou para prestar os serviços que necessita;",
    setup207: "4) Processar as suas informações pessoais divulgadas por si ou outras informações pessoais que tenham sido legalmente divulgadas (tais como informações pessoais legalmente divulgadas através de notícias legais, divulgação de informações governamentais ou outros canais) num âmbito razoável;",
    setup208: "5) Lidar com disputas ou litígios entre si e outras pessoas de acordo com as suas necessidades;",
    setup209: "6) Cumprir os acordos relevantes assinados consigo (incluindo acordos eletrónicos online e regras de plataforma correspondentes) ou outros documentos legais;",
    setup210: "7) Utilização com base em interesses públicos sociais e emergências de saúde pública e em conformidade com as leis e regulamentos.",
    setup211: "Para os fins acima referidos, também tem o direito de cancelar esta notificação a qualquer momento. Pode iniciar sessão no site 51shopy e configurá-la você mesmo na função personalizada.",
    setup212: "Por favor, note que não partilharemos os seus dados pessoais com qualquer anunciante, a menos que obtenhamos o seu consentimento. Não solicitaremos ou divulgaremos informações pessoais a crianças ou outras pessoas incapazes sem o consentimento, conhecimento e presença dos seus responsáveis.",
    setup213: "Reconhece, partilha e transfere informações pessoais não identificadas e garante que o destinatário dos dados não pode restaurar e reidentificar o assunto das informações pessoais, o que não constitui a partilha, transferência e divulgação pública de informações pessoais para o exterior. O armazenamento e tratamento de tais dados não exigem notificação a si e ao seu consentimento.",
    setup214: "Podemos confiar aos parceiros autorizados o processamento das suas informações pessoais para que estes lhe possam fornecer determinados serviços ou desempenhar determinadas funções em nosso nome. Apenas confiaremos o processamento das suas informações para os fins legítimos, adequados, necessários, específicos e claros declarados nesta política, e os parceiros autorizados apenas poderão aceder às informações necessárias para desempenhar as suas funções. A 51shopy não fornecerá o seu endereço de e-mail, nome e palavra-passe da conta do site 51shopy, informações de contacto e outras informações privadas aos nossos parceiros.",
    setup215: "3. Durante quanto tempo conservaremos as suas informações?",
    setup216: "Depois de registar com sucesso uma conta 51shopy, guardaremos permanentemente as suas informações pessoais. Se pretender cancelar a sua conta ou eliminar as suas informações pessoais, contacte o serviço de apoio ao cliente online.",
    setup217: "De acordo com o RGPD, os responsáveis ​​pelo tratamento e subcontratantes são obrigados a devolver ou eliminar todos os dados pessoais após o término do serviço ou expiração do contrato ou acordo, a menos que exista um requisito legal para reter os dados.",
    setup218: "4. Como protegemos as suas informações pessoais",
    setup219: "Tomaremos todas as medidas razoáveis ​​e viáveis ​​para proteger as suas informações pessoais. Tomaremos todas as medidas razoáveis ​​e viáveis ​​para garantir que nenhuma informação pessoal irrelevante é recolhida.",
    setup220: "5. Atualização da política",
    setup221: "Para lhe trazer uma melhor experiência de produto e serviço, estamos constantemente a trabalhar para melhorar os nossos produtos, serviços e tecnologias. Quando os novos serviços e processos de negócio mudarem, podemos atualizar a nossa política de privacidade para o informar sobre alterações específicas. Por favor, preste atenção a esta página em tempo útil e siga a política mais recente na página. Assim que a política mais recente for lançada, será vinculativa para si.",
    setup222: "6. Contacte-nos",
    setup223: "Se tiver alguma dúvida sobre esta declaração de privacidade, por favor contacte: ",
    setup224: "Leia atentamente os Termos de Serviço da 51shopy antes de se registar como utilizador e certifique-se de que compreende completamente estes termos. Leia atentamente e escolha aceitar ou não os Termos de Serviço da 51shopy, especialmente os termos de isenção ou limitação de responsabilidade, a lei aplicável e a resolução de litígios. A menos que aceite estes Termos de Serviço da 51shopy, não tem o direito de se registar, iniciar sessão ou utilizar os serviços da 51shopy. O seu registo, login e utilização serão considerados como a sua aceitação dos Termos de de Serviço da 51shopy e a sua concordância em comprometer-se com os Termos de Serviço da 51shopy.",
    setup225: "Os Termos de Serviço da 51shopy estipulam os direitos e obrigações de si e da 51shopy em relação aos serviços da 51shopy (doravante designados por 'Serviços'). Os Termos de Serviço da 51shopy podem ser atualizados pela 51shopy a qualquer momento. Os Termos de Serviço atualizados da 51shopy substituirão os termos originais uma vez publicados e divulgados sem aviso prévio. Pode verificar a versão mais recente dos Termos de Serviço da 51shopy na plataforma da y. É também recomendável que se mantenha atualizado sobre os Termos de Serviço atualizados da 51shopy para evitar mal-entendidos e disputas desnecessárias. Após a modificação dos Termos de Serviço da 51shopy, se não aceitar os termos modificados, pare de utilizar os serviços prestados pela 51shopy imediatamente.",
    setup226: "1. Âmbito de aplicação dos presentes Termos de Serviço",
    setup227: "Os direitos de propriedade e operação dos serviços de usuário registrados relevantes pertencem à . Os serviços fornecidos devem ser implementados de acordo com as regras de serviço, termos e especificações operacionais emitidas por ela, o que também significa que os usuários relevantes chegaram a um acordo com a 51shopy e aceitaram todos os seus termos de serviço.",
    setup228: "2. Recolha e utilização de informação",
    setup229: "Quando utiliza os serviços da 51shopy, podemos ter de recolher e utilizar os dois tipos de informações pessoais seguintes:",
    setup230: "1. Para lhe fornecer as funções básicas dos nossos serviços, deve autorizar-nos a recolher e utilizar as informações necessárias. Se se recusar a fornecer as informações correspondentes, não poderá registar-se, iniciar sessão ou utilizar os nossos serviços normalmente;",
    setup231: "2. Para lhe fornecer recursos adicionais dos nossos serviços, pode optar por concordar ou discordar das informações que recolhemos e utilizamos. Se se recusar a fornecer, não poderá utilizar os recursos adicionais relevantes ou obter os efeitos funcionais que pretendemos obter, e isso não afetará a sua utilização das nossas funções básicas.",
    setup232: "Protegemos o seu direito de saber e o direito de escolher durante o processo de instalação ou utilização de acordo com a lei. Quando utiliza os serviços da 51shopy, os serviços que envolvem funções fornecidas no seu dispositivo requerem o seu consentimento prévio. Após a sua confirmação, a 51shopy tem o direito de ativar as funções auxiliares necessárias, tais como recolha de localização geográfica, leitura de catálogo de endereços, utilização de câmara e ativação de serviços de gravação.",
    setup233: "As informações recolhidas e utilizadas incluem, mas não estão limitadas ao nome do utilizador, informações de contacto e outras informações básicas. O utilizador concorda que a utilização destas informações está sujeita às disposições do Artigo 3 'Proteção da Informação do Utilizador'.",
    setup234: "3. Proteção da informação do utilizador",
    setup235: "Não divulgaremos ou revelaremos as suas informações pessoais a terceiros, a menos que:",
    setup236: "1. Partilha necessária para cumprir as obrigações legais;",
    setup237: "2. Partilha com o seu consentimento;",
    setup238: "4. Direitos e obrigações do utilizador",
    setup239: "1. Tem o direito de iniciar sessão no site 51shopy para rever, corrigir e complementar as suas informações pessoais.",
    setup240: "2. Tem o direito de contactar o serviço de apoio ao cliente online para cancelar a sua conta. Após cancelar a sua conta, deixaremos de lhe prestar serviços e eliminaremos ou tornaremos anónimas as suas informações pessoais de acordo com os requisitos das leis relevantes.",
    setup241: "3. Em determinadas funções comerciais, podemos tomar decisões com base apenas em mecanismos de tomada de decisão automatizados não humanos, incluindo algoritmos. Se estas decisões afetarem os seus direitos legais, pode contactar-nos através do serviço de apoio ao cliente.",
    setup242: "4. Todas as informações que fornecer à 51shopy serão verdadeiras, precisas e não enganosas.",
    setup243: "Compreende e concorda que é obrigado a manter a autenticidade e a validade das informações fornecidas.",
    setup244: "5. Não pode utilizar a sua conta registada ou os serviços da 51shopy para criar, carregar, copiar, publicar ou disseminar conteúdo que interfira com o funcionamento normal da 51shopy ou infrinja os direitos e interesses legítimos de outros utilizadores ou terceiros.",
    setup245: "6. Não pode copiar, plagiar, vender, revender ou utilizar para quaisquer outros fins comerciais qualquer parte do serviço 51shopy ou o conteúdo utilizado ou obtido através do serviço 51shopy.",
    setup246: "7. Será o único responsável pela autenticidade, legalidade, precisão e validade de qualquer informação transmitida através da sua conta 51shopy ou dos serviços 51shopy. Qualquer responsabilidade legal relacionada com qualquer informação que transmita será suportada por si e não tem nada a ver com a 51shopy. Deverá compensar quaisquer perdas causadas à 51shopy ou a terceiros, e a 51shopy reserva-se o direito de responsabilizar os utilizadores e utilizadores relevantes.",
    setup247: "8. Será totalmente responsável pelas consequências de todas as ações tomadas na sua conta (incluindo, mas não se limitando a, assinar vários acordos online, publicar informações, comprar bens e serviços e divulgar informações).",
    setup248: "5. Armazenamento de informação",
    setup249: "51shopy' não tem limite superior para a quantidade de informações transmitidas. Tomamos medidas de segurança razoáveis ​​que cumpram as normas da indústria para proteger as suas informações e evitar que as informações pessoais sejam acedidas, divulgadas, utilizadas, modificadas, danificadas ou perdidas sem autorização.",
    setup250: "6. Isenção de responsabilidade",
    setup251: "A 1.51shopy fará o seu melhor para restaurar a situação real da informação do produto fornecida, mas devido à influência de vários fatores, tais como o ambiente circundante, ângulo de filmagem, diferenças de equipamento, etc. durante o processo de filmagem do produto, não podemos garantir que o produto seja exatamente o mesmo que o real.",
    setup252: "A 2.51shopy compra produtos designados com base na plataforma especificada pelo utilizador. Se a plataforma que especificar estiver esgotada, o preço mudar, a entrega atrasar, o produto real não corresponder às informações do produto no site, o produto for anormal ou outros fatores de força maior levarem à incapacidade de comprar normalmente, entraremos em contacto consigo a tempo. Por conseguinte, a '51shopy' não assume qualquer responsabilidade pelas perdas que lhe foram causadas.",
    setup253: "3. Se os produtos que comprou na 51shopy envolverem problemas de pós-venda (como falta de stock, danos, defeitos, etc.), iremos resolvê-los para si em tempo útil.",
    setup254: "4. A 51shopy não assume qualquer responsabilidade por perdas ou consequências causadas pela divulgação proativa da sua conta 51shopy ou por ataques, fraudes, etc. por terceiros. Deve pedir indemnização ao infrator através de recursos legais ou outros meios.",
    setup255: "7. Comportamento Proibido",
    setup256: "Não pode utilizar os serviços do 51shopy para as seguintes atividades:",
    setup257: "(1) Violação de qualquer lei, estatuto, decreto ou regulamento.",
    setup258: "(2) Estão envolvidas as seguintes transações:",
    setup259: "(a) estupefacientes, esteróides, certas drogas controladas ou outros produtos que possam pôr em perigo a segurança do consumidor;",
    setup260: "(b) apetrechos para drogas;",
    setup261: "(c) Cigarros;",
    setup262: "(d) canábis não autorizada ou outras plantas psicoativas;",
    setup263: "(e) nutrição baseada em subscrição, vitaminas, suplementos, ervas e produtos naturais para a saúde;",
    setup264: "(f) qualquer material que instigue, induza, auxilie ou encaminhe outros a envolverem-se em atividades ilegais;",
    setup265: "(g) artigos roubados, incluindo artigos digitais e virtuais;",
    setup266: "(h) materiais que incitem ao ódio, à violência, à intolerância racial ou a outras formas de intolerância ou explorem atividades criminosas;",
    setup267: "(i) considerado obsceno;",
    setup268: "(j) qualquer material que infrinja ou viole direitos de autor, marcas registadas, publicidade ou privacidade ou qualquer outro direito de propriedade ao abrigo das leis de qualquer jurisdição;",
    setup269: "(k) certos materiais ou serviços pornográficos;",
    setup270: "(l) munições, armas ou certas partes ou acessórios de armas, ou",
    setup271: "(m) Certas armas ou facas reguladas pela lei aplicável.",
    setup272: "（3）Relacionado com as seguintes transações:",
    setup273: "(a) Divulgação de informações pessoais de terceiros em violação das leis relevantes;",
    setup274: "(b) suporta esquemas de pirâmide, esquemas Ponzi, esquemas de matriz, outros esquemas para enriquecimento rápido ou certos esquemas de downline multinível;",
    setup275: "(c) transações relacionadas com a compra de anuidades ou contratos de lotaria, sistemas de compra de depósitos pré-pagos, serviços bancários offshore ou transações para financiar ou refinanciar dívidas de cartão de crédito;",
    setup276: "(d) vender algo antes de o vendedor ter o controlo ou a posse do mesmo;",
    setup277: "(e) os processadores de pagamento cobram os pagamentos em nome dos comerciantes;",
    setup278: "(f) no âmbito da venda de cheques de viagem ou ordens de pagamento;",
    setup279: "(g) que envolvam operações de câmbio ou desconto de cheques;",
    setup280: "(h) envolva determinados serviços de reparação de crédito ou liquidação de dívidas, transações com cartão de crédito ou atividades de seguros, ou",
    setup281: "(i) envolva fazer ou receber pagamentos relacionados com suborno ou corrupção.",
    setup282: "(4) Envolvendo a venda de produtos ou serviços que as agências governamentais determinaram que podem ser fraudulentos.",
    setup283: "Será legalmente responsável pela utilização dos serviços da 51shopy, incluindo, mas não se limitando a, indemnização por perdas à parte violada e, após a 51shopy assumir a primeira responsabilidade legal, tais como penalidades administrativas ou indemnização por infração causada pelo comportamento do utilizador, pagará à 51shopy um valor igual de indemnização e outras perdas sofridas pela 51shopy como resultado.",
    setup284: "8. Responsabilidade de Compensação",
    setup285: "1. Se as suas ações fizerem com que a 51shopy e/ou as suas afiliadas sofram perdas (incluindo perdas económicas diretas, perda de goodwill e perdas económicas indiretas, tais como indemnização, acordo, honorários de advogados, seguro de preservação, taxas de litígio, etc.), deverá indemnizar a 51shopy e/ou as suas afiliadas por todas as perdas.",
    setup286: "2. Se as suas ações fizerem com que a 51shopy e/ou as suas afiliadas sejam processadas por terceiros (incluindo, mas não se limitando a vendedores no Taobao, 1688 e outras plataformas), a 51shopy e/ou as suas afiliadas poderão recuperar todas as perdas de si após assumir obrigações como compensação monetária ao terceiro.",
    setup287: "9. Lei aplicável e jurisdição",
    setup288: "1. Este Contrato de Serviço e qualquer contrato separado pelo qual lhe prestamos serviços serão regidos e interpretados de acordo com as leis de Hong Kong.",
    setup289: "2. Quaisquer litígios decorrentes da sua utilização dos serviços da 51shopy e litígios relacionados com os serviços da 51shopy serão resolvidos através de negociação entre a 51shopy e o utilizador. Se a negociação falhar, qualquer das partes poderá intentar uma ação judicial no tribunal com jurisdição sobre o local onde este acordo for assinado.",
    setup290: "A seguir é apresentado o horário de saída do depósito (enviado para o depósito do fornecedor de logística)/retirada do fornecedor de logística, apenas para referência (o horário real está sujeito aos acordos de cada fornecedor de logística):",
    setup291: "Horário de entrega/recolha do pacote:",
    setup292: "Quando o estado do pacote no armazém da 51shopy for 'Embalado', o armazém e a empresa de logística providenciarão a entrega/recolha dentro de um horário fixo (a empresa de logística encerra aos fins de semana e feriados, e o levantamento será adiado).",
    setup293: "Rota",
    setup294: "Programação de envio/recolha (hora de Pequim)",
    setup295: "GD-EMS",
    setup296: "Levantamento de segunda a domingo",
    setup297: "GD-EUB",
    setup298: "Levantamento de segunda a domingo",
    setup299: "GD-E-EMS",
    setup300: "Levantamento de segunda a domingo",
    setup301: "EUB-T",
    setup302: "Levantamento de segunda a domingo",
    setup303: "DHL Express",
    setup304: "Levantamento de segunda a sábado",
    setup305: "DHL Heavy Cargo Standard Express",
    setup306: "Levantamento de segunda a sábado",
    setup307: "Linha Especial Europeia DHL",
    setup308: "Envio de segunda-feira a domingo (entrega no armazém do fornecedor de logística)",
    setup309: "Linha Americana (Pequena)",
    setup310: "Envio de segunda a domingo (entrega no armazém do fornecedor de logística)",
    setup311: "Linha Britânica (Pequena)",
    setup312: "Envio de segunda a domingo (entrega no armazém do fornecedor de logística)",
    setup313: "EMS da Coreia",
    setup314: "Envio do nosso armazém todos os dias",
    setup315: "Pacote Postal PDB",
    setup316: "Haibao",
    setup317: "Ferrovias Europeias",
    setup318: "United Parcel Service Hong Kong Limitada",
    setup319: "Linha dedicada Aramex",
    setup320: "SAL",
    setup331: "EMS",
    setup332: "PD-EUB",
    setup333: "Linha Britânica",
    setup334: "NH-EMS",
    setup335: "Linha franca europeia",
    setup336: "Linha Americana",
    setup337: "YTO Expresso",
    setup338: "SF Expresso",
    setup339: "A 51shopy é uma plataforma que fornece serviços de compras e encaminhamento de produtos chineses, fornecendo aos utilizadores serviços de pesquisa de informações sobre produtos, compras e encaminhamento. Durante este período, a 51shopy fornece serviços básicos de inspeção de produtos, confirmação de comunicação com comerciantes e serviços pós-venda para proteger os seus direitos e interesses legais e garantir a sua experiência de compra.",
    setup340: "Se achar que os produtos adquiridos são falsificados ou inferiores, por favor contacte o nosso serviço de apoio ao cliente ou envie um e-mail para",
    setup341: "1. Receção e inspeção: Após a verificação da qualidade do produto e o seu envio para o armazém da 51shopy, ou após a receção do pacote, caso encontre algum problema de qualidade no produto ou tenha dúvidas sobre a sua autenticidade, contacte o serviço de apoio ao cliente o mais rapidamente possível e forneça as provas relevantes.",
    setup342: "2. Materiais de reclamação: Forneça o formulário de encomenda, recibo de pagamento, descrição do produto e provas de produtos falsificados ou inferiores.",
    setup343: "3. Após receber os seus materiais de reclamação, a nossa equipa de atendimento ao cliente compreenderá os detalhes consigo e ajudá-lo-á a comunicar com o vendedor para resolver o problema e a esforçar-se para lutar pelos seus direitos legais.",
    setup344: "Tenha em atenção que, devido à autenticidade do produto, podem ser necessárias avaliações profissionais e procedimentos legais adicionais. Se for necessária uma agência de avaliação profissional, a taxa de avaliação será paga por si. Para proteger os direitos e interesses de todas as partes, recomendamos que escolha canais formais e vendedores de confiança ao comprar para reduzir o risco de adquirir produtos falsificados.",
    setup345: "Qual é a garantia de devolução/troca de 14 dias?",
    setup346: "A garantia de devolução e troca de cinco dias é um serviço especial de pós-venda (incluindo o serviço em si e o suporte técnico) prestado pelos vendedores de plataformas de terceiros aos consumidores. No prazo de 14 dias após a subscrição dos bens (ou seja, no prazo de 14 dias após os bens serem colocados em armazenamento), os compradores podem devolver ou trocar os bens adquiridos de acordo com esta regra e as regras relevantes emitidas pela plataforma de terceiros.",
    setup347: "Como posso determinar se um produto é elegível para uma garantia de devolução/troca?",
    setup348: "Os produtos são 'qualificados' para o serviço de devolução e troca gratuito de 14 dias ou 'não qualificados' para o serviço de devolução e troca gratuito de 14 dias",
    setup349: "Está disponível?",
    setup350: "Tipo",
    setup351: "Por exemplo",
    setup352: "Não disponível",
    setup353: "Determinado com base nas informações fornecidas pelo comerciante. Se não pudermos confirmar, negociaremos com o vendedor sobre a devolução/troca, mas o resultado final está sujeito à decisão do vendedor.",
    setup354: "Personalização",
    setup355: "Produtos de design personalizados",
    setup356: "Explicitamente não suporta devoluções e trocas",
    setup357: "Promover produtos defeituosos",
    setup358: "Produtos cujas embalagens, rótulos e acessórios foram removidos a pedido do utilizador",
    setup359: "A etiqueta da roupa está rasgada",
    setup360: "Jornais e periódicos",
    setup361: "Livros e periódicos assinados",
    setup362: "Produtos em segunda mão",
    setup363: "Produtos fora da China continental",
    setup364: "Produtos adquiridos no estrangeiro e em Hong Kong e Macau",
    setup365: "Roupa interior",
    setup366: "Roupa interior, meias, leggings",
    setup367: "Produtos para adultos",
    setup368: "Outros assuntos especificados pelo vendedor",
    setup369: "Cumprir as regras do vendedor",
    setup370: "Alimentação",
    setup371: "Bolachas, doces, etc.",
    setup372: "Livros (≥15 livros)",
    setup373: "Não menos de 15 livros",
    setup374: "Artigos que foram abertos e necessitam de cumprir os 'padrões especiais' para a embalagem de devolução.",
    setup375: "Para produtos de vedação, consulte a tabela em anexo",
    setup376: "Disponível",
    setup377: "Para pedidos de devolução/troca enviados no prazo de 14 dias a contar da receção, iremos processá-los de acordo com os procedimentos padrão.",
    setup378: "Quando o produto cumpre todos os seguintes requisitos:",
    setup379: "1. O vendedor oferece uma garantia de devolução;",
    setup380: "2. Em condições de revenda, conforme exigido pelo vendedor;",
    setup381: "3. O tempo de armazenamento não é superior a 14 dias.",
    setup382: "Para produtos que oferecem envio gratuito, será responsável pelos custos de envio quando devolver o produto. Para produtos que não oferecem envio gratuito, será responsável pelos custos de envio quando o vendedor enviar o produto para o nosso armazém e quando devolver o produto ao vendedor.",
    setup383: "Como solicitar o serviço de devolução/troca",
    setup384: "No prazo de 14 dias após o estado da encomenda mudar para 'Inventário' (calculado a partir da hora seguinte após o estado mudar para 'Inventário', 14 dias = 336 horas), pode solicitar o serviço de devolução e troca na página. As encomendas podem não ser aceites após o limite de tempo.",
    setup385: "Precauções e perguntas frequentes",
    setup386: "Notas:",
    setup387: "O valor total do reembolso/troca é baseado no preço real do produto que pagou",
    setup388: "Só lhe podemos devolver/trocar produtos se o vendedor concordar",
    setup389: "Após solicitar o serviço de devolução/troca, certifique-se de que existe saldo suficiente na sua conta para pagar os portes de devolução e a taxa de serviço.",
    setup390: "Consulte a tabela abaixo para os requisitos de embalagem de devolução de alguns produtos. Se os requisitos não forem cumpridos, não poderá devolver/trocar o produto.",
    setup391: "Padrões Especiais",
    setup392: "Categoria do produto",
    setup393: "Padrões Especiais",
    setup394: "Novos sapatos desportivos",
    setup395: "Os fechos anti-roubo (se existirem) e os adesivos anti-violação não foram cortados/removidos e estão totalmente funcionais.",
    setup396: "Detergente / Penso Interno / Papel / Perfume",
    setup397: "Os recipientes selados de uso único para produtos de higiene pessoal, caso existam, devem permanecer selados.",
    setup398: "Cuidados do cabelo/Perucas",
    setup399: "As embalagens seladas de utilização única para produtos de cuidado capilar (se existirem) devem permanecer seladas.",
    setup400: "Cuidados da pele/Cuidados do corpo/Óleos essenciais",
    setup401: "A embalagem descartável selada do produto (se existir) deve permanecer selada",
    setup402: "Cosmética/Perfumes/Ferramentas de beleza",
    setup403: "Produtos digitais/eletrodomésticos (excluindo câmaras fotográficas e grandes eletrodomésticos)",
    setup404: "1. A licença de acesso à Internet não está danificada (destruída).",
    setup405: "2. Sem danos causados ​​pela água.",
    setup406: "Câmara digital/Câmara SLR/Câmara",
    setup407: "O botão do obturador de uma câmara SLR não deve ser premido mais de 20 vezes.",
    setup408: "Eletródomésticos de grande porte",
    setup409: "1. TV LCD, ar condicionado: ainda não instalado na parede, depuração simples disponível.",
    setup410: "2. Máquina de lavar roupa: ainda não foi utilizada com água.",
    setup411: "Modelos/Periféricos de anime/Periféricos de anime/Produtos de RPG/Jogos de tabuleiro",
    setup412: "A fita e os selos plásticos (se existirem) nos modelos, estatuetas, modelos de soldados, BJD e outros produtos não podem ser removidos.",
    setup413: "Componentes Electrónicos",
    setup414: "1. A soldadura é proibida.",
    setup415: "2. O circuito integrado nunca foi montado em nenhuma base de CI.",
    setup416: "3. As embalagens descartáveis ​​lacradas de consumíveis como massa térmica/pasta térmica, cola eletrónica/cola de encapsulamento/selante/adesivo, cola condutora, tinta condutora, etc. devem ser mantidas seladas.",
    setup417: "Subcategoria 'Software de jogo' na categoria de primeiro nível 'Videojogos/Acessórios/Jogos/Guias de jogo",
    setup418: "Alimentos para animais de estimação, produtos de saúde e medicamentos na categoria de primeiro nível 'Animais de estimação/Alimentos e artigos para animais de estimação",
    setup419: "Livros/Revistas",
    setup420: "1. A embalagem descartável selada do produto (se existir) deve permanecer selada",
    setup421: "2. O produto não deve apresentar marcas de dobra, manchas de água, sujidade, tinta ou leitura.",
    setup422: "Categoria secundária 'Produtos de saúde animal/Medicamentos veterinários' na categoria primária 'Criação animal/Produtos agrícolas'",
    setup423: "As embalagens seladas de utilização única (se existirem) para produtos como alimentos (incluindo suplementos), cosméticos, dispositivos médicos, contracetivos, produtos de higiene pessoal, produtos para adultos, fraldas para bebés, livros e produtos audiovisuais devem permanecer seladas.",
    setup424: "'Selagem' refere-se ao selo ou à embalagem de plástico utilizado pelo fabricante na embalagem do produto.",
    setup425: "Perguntas frequentes:",
    setup426: "1. O que devo fazer se um pedido que não está coberto pela 'Garantia de Devolução e Troca' tiver problemas de pós-venda?",

    setup427: "Quando houver problemas de qualidade com o produto, a 51shopy verificará com o vendedor com base na situação real, formulará uma solução final e notificará o utilizador. Se não houver problemas de qualidade com o produto, de acordo com as regras da plataforma de terceiros, os serviços de devolução e troca não poderão ser prestados. A 51shopy tentará o seu melhor para comunicar com o vendedor para proteger os direitos e interesses dos utilizadores.",
    setup428: "2. Quem é responsável pelo envio quando se utiliza a 'Garantia de Devolução/Troca'? ",
    setup429: "Antes de solicitar o serviço de devolução e troca, o produto deve ser novo e cumprir as condições de revenda. Se o produto não apresentar problemas de qualidade, o custo do envio será suportado pelo utilizador. Se o produto apresentar problemas de qualidade, o vendedor suportará o custo do envio após o utilizador enviar o pedido.",
    setup430: "3. Se o estado da encomenda for não enviado, há alguma cobrança pelo serviço de devolução?",
    setup431: "Não se preocupe, não há cobrança neste caso. Só será cobrado se o pedido de devolução cumprir três condições: primeiro, o produto não tem problemas de qualidade. Segundo, o produto já está em stock no armazém. Terceiro, utilizou o número de devoluções gratuitas deste mês. Por isso, não lhe cobraremos nada quando o produto não tiver sido enviado.",
    setup432: "E-mail:",
    setup433: "Telefone: +85251387262",
    setup434: "Morada: Sala 341, 3/F, Public Industrial Building, 56 Hoi Yuen Road, Kwun Tong, Hong Kong",
    setup435: "Desenvolvido por 51shopy - Space Network Technology Co., Ltd.",
    setup436: "Ajudá-lo no processamento",
    setup437: "Saldos quentes de ontem",
    setup438: "Venda quente",
    setup439: "Vendido",
    setup440: "Falha no pagamento",
    setup441: "Aguarda pagamento de portes",
    setup442: "Postagem paga, a aguardar confirmação do banco",
    setup443: "Postagem paga",
    setup444: "Especificações",
    setup445: "Pagamento Real",
    setup446: "É recomendável que considere cuidadosamente antes de cancelar um pedido. A plataforma não será responsável pelo cancelamento de um pedido!",
    setup447: "Alternar pagamento",
    setup448: "Pagar portes",
    setup449: "Encomenda de shopping",
    setup450: "Mais",
    setup451: "Shopping",
    setup452: "Compras",
    setup453: "Libertar",
    setup454: "Vender",
    setup455: "Histórico",
    setup456: "Ordem de compra",
    setup457: "Valor a pagar",
    setup458: "Entrar na loja",
    setup459: "Ver mais",
    setup460: "Recolher",
    setup461: "Entrar",
    setup462: "O produto está esgotado.",
    setup463: "Recomendamos os seguintes produtos semelhantes",
    setup464: "Produtos semelhantes",
    setup465: "Aviso Legal",
    setup467: "Embalagem refere-se à embalagem original do produto. Se inspecionada, a embalagem logística será removida, exceto o produto em si. Para evitar danos no produto, os materiais de embalagem de proteção necessários serão retidos. Não somos responsáveis ​​se solicitar a remoção da embalagem.",
    setup468: "Envio nacional abrangente Para mercadorias do mesmo vendedor, o desvio de envio será ajustado por nós.",
    setup469: "Para cada produto, tiraremos 3 a 7 fotografias para si gratuitamente. Se tiver requisitos adicionais para serviços fotográficos requintados, poderemos cobrar uma pequena taxa de serviço.",
    setup470: "Os produtos personalizados não aceitam devoluções ou trocas.",
    setup471: "Para produtos aprovados para devolução e troca pelo comerciante, pode solicitar a devolução e troca no prazo de 14 dias após o estado da encomenda mudar para 'Em stock'. Quando solicita uma devolução e troca, tem de suportar uma taxa de manuseamento de cerca de 0,75 dólares e custos de envio doméstico para cada devolução de produto diferente, o valor total é de cerca de 3 dólares.",
    setup472: "Todos",
    setup473: "Rota de postagem",
    setup474: "Taxa de envio",
    setup475: "São necessárias informações de comprimento, largura e altura do pacote",
    setup476: "Tempo de transporte",
    setup477: "dia",
    setup478: "Isento de impostos",
    setup479: "Pode ser segurado",
    setup480: "Estimativa",
    setup481: "Recuperar registo de palavra-passe",
    setup482: "Comerciante",
    setup483: "Por favor",
    setup484: "Pague, caso contrário a encomenda será cancelada",
    setup485: "Preço total dos produtos",
    setup486: "Valor pago",
    setup487: "Pague agora",
    setup488: "O saldo é insuficiente, recarregue e pague",
    setup489: "Nenhum método de pagamento adequado? Pode tentar pagar com o seu saldo primeiro",
    setup490: "Já em stock",
    setup491: "O frete foi cotado",
    setup492: "Taxa de envio paga",
    setup493: "Envio fora de stock",
    setup494: "Continuar a pagar",
    setup495: "Número do pedido de logística internacional",
    setup496: "Número do pedido de logística doméstica",
    setup497: "O seu browser não suporta o leitor de vídeo HTML5.",
    setup498: "Apenas suporta o upload de imagens em formato PNG e JPEG!",
    setup499: "Concluído",
    setup500: "regressar",
    setup501: "Não tem permissão para aceder a esta página",
    setup502: "Cálculo de transporte",
    setup503: "Cooperar com muitas empresas de logística para fornecer os descontos mais favoráveis",
    setup504: "Estimativa do custo de envio",
    setup505: "Pesquisar produtos",
    setup506: "Visualizar produtos com base em critérios de pesquisa",
    setup507: "Informações básicas",
    setup508: "Por favor, introduza o nome em inglês",
    setup509: "Por favor, introduza o nome chinês",
    setup510: "Os vídeos enviados só podem estar nos formatos MP4, WebM ou OGG!",
    setup511: "O tamanho do vídeo enviado não pode exceder 2 MB!",
    setup512: "A duração do vídeo não pode exceder",
    setup513: "segundos",
    setup514: "Não foi possível obter a duração do vídeo, verifique se o ficheiro de vídeo está danificado",
    setup515: "dados",
    setup516: "",
    setup517: "Por favor, introduza o sku",
    setup518: "Por favor introduza a quantidade",
    setup519: "Por favor, introduza o preço",
    setup520: "Por favor, introduza os detalhes do produto em inglês",
    setup521: "Por favor, introduza os detalhes do produto chinês",
    setup522: "Chinês simplificado",
    setup523: "Espanhol",
    setup524: "Português",
    setup525: "Holandês",
    setup526: "Polonês",
    setup527: "Alemão",
    setup528: "Francês",
    setup529: "Italiano",
    setup530: "Ativar múltiplas especificações",
    setup531: "Preço (CNY)",
    setup532: "Adic.Fotos Spec",
    setup533: "Adic. Val. Spec",
    setup534: "① Clique duas vezes para modificar, arraste para ajustar a ordem",
    setup535: "Adicionar especificações",
    setup536: "Definições em lote",
    setup537: "Por favor, publique no lado do PC",
    setup538: "Nome",
    setup539: "Carregar vídeo do produto",
    setup540: "hora de entrada no armazém",
    setup541: "hora de saída do armazém",
    setup543: "O meu lançamento",
    setup544: "Por favor, autentique-se como comerciante antes de publicar o produto",
    setup545: "Vá para o lado do PC para publicar o produto",
    setup546: "destino",
    setup547: "Estados Unidos da América",
    setup548: "Peso (gramas)",
    setup549: "Categoria do produto",
    setup550: "Selecione a categoria",
    setup551: "comprimento",
    setup552: "largura",
    setup553: "altura",
    setup554: "CONSULTA",
    setup555: "abrangente",
    setup556: "Pode ser segurado",
    setup557: "isento de impostos",
    setup558: "taxa de envio",
    setup559: "Precisa de informação sobre o comprimento, largura e altura do pacote",
    setup560: "Tempo de transporte",
    setup561: "dias",
    setup562: "Cancelar pagamento ustd com sucesso!",
    setup563: "dayReminder: Selecione o seu país de destino e o sistema irá pesquisar as rotas disponíveis nesses locais",
    setup564: "Restrições de pacotes",
    setup565: "Limite mínimo de peso:",
    setup566: "Limite máximo de peso:",
    setup567: "Regras de cobrança de peso por volume:",
    setup568: "Limite de tamanho:",
    setup569: "Não foi possível enviar",
    setup570: "Pode enviar",
    setup571: "Padrões de taxas:",
    setup572: "unidade de peso",
    setup573: "preço unitário",
    setup574: "Taxa alfandegária",
    setup575: "Custo do combustível",
    setup576: "Taxa de operação",
    setup577: "O limite de crédito deste banco é insuficiente, pelo que não pode selecionar este banco!",
    setup578: "O saldo de 51coins é insuficiente, por favor recarregue!",
    setup579: "observação",
    setup580: "Selecione o produto que pretende eliminar!",
    setup581: "Entrar com o Google",
    setup582: "A primeira imagem é a principal por padrão. Arraste para alterar.",
    setup583: "Limite máximo de upload atingido",
    setup584: "Iniciar sessão utilizando o Telegram",
    setup585: "Ver logística",
    setup586: "Informações logísticas",
    setup587: "Modificar número do pedido de logística",
    setup588: "Ligar e- mail",
    setup589: "Por favor, ligue o seu e-mail primeiro",
    setup590: "Pode introduzir até 2 tipos de especificação!",
    setup591: "Modelos comuns",
    setup592: "Selecionar modelo",
    setup593: "Cancelar",
    setup594: "Adicionar",
    setup595: "Selecione o valor da especificação",
    setup596: "Não adicione repetidamente",
    setup597: "Configurou modelos comuns com sucesso!",
    setup598: "O SKU não pode estar vazio",
    setup599: "O preço não pode estar vazio",
    setup600: "A quantidade não pode estar vazia",
    setup601: "Não é possível adicionar o mesmo valor de especificação!",
    setup602: "① Clique duas vezes para modificar",
    setup603: "Por favor, preencha a informação de especificação!",
    setup604: "Por favor, preencha os dados do produto em chinês simplificado e inglês!",
    setup605: "Modificação bem-sucedida",
    setup606: "Adicionado valor de especificação com sucesso!",
    setup607: "Definir como comum",
    setup608: "Preencha pelo menos um valor de especificação!",
    setup609: "Por favor, introduza chinês simplificado",
    setup610: "Por favor, introduza inglês",
    setup611: "Por favor, introduza espanhol",
    setup612: "Por favor, introduza português",
    setup613: "Por favor, introduza holandês",
    setup614: "Por favor, introduza polaco",
    setup615: "Por favor, introduza alemão",
    setup616: "Por favor, introduza francês",
    setup617: "Por favor, introduza italiano",
    setup618: "Tradução automática",
    setup619: "Tradução",
    setup620: "Todos os outros",
    setup621: "INFORMAÇÃO DE ENVIO",
    setup622: "O nosso objetivo é oferecer-lhe as melhores opções de envio, independentemente do local onde vive. Entregamos a centenas de clientes em todo o mundo todos os dias, e esforçamo-nos para lhe fornecer serviços do mais alto nível.",
    setup623: "A. O prazo de entrega de uma encomenda é dividido em duas partes:",
    setup624: "· Tempo de processamento: 3-7 dias",
    setup625: "· Tempo de envio: 14 a 30 dias",
    setup626: "B.Métodos de envio",
    setup627: "C. Taxa de envio",
    setup628: "Direitos de Propriedade Intelectual",
    setup629: "Transporte Terrestre/Marítimo",
    setup630: "Aguarda receção",
    setup631: "aliança",
    setup632: "Partilhe o seu código de afiliado",
    setup633: "Os amigos que convidou confirmam que receberam o seu código de aliança",
    setup634: "Receba a sua comissão de afiliado",
    setup635: "Copie este URL e utilize-o para redirecionar os utilizadores para a página inicial do seu ID de afiliado",
    setup636: "Copiar URL",
    setup637: "A Minha Aliança",
    setup638: "Gravar",
    setup639: "Obter",
    setup640: "Perguntas frequentes sobre ações",
    setup641: "O que é o programa de afiliados?",
    setup642: "O 51Shopy é um projeto de partilha e geração de rendimentos iniciado por todos os utilizadores. Seja você um indivíduo ou um vendedor, junte-se a um promotor do 51Shopy, convide novos utilizadores a registarem-se no 51Shopy e realize uma compra com sucesso. Ele(a) tornar-se-á seu(sua) utilizador(a) exclusivo(a), e cada consumo dele(a) em logística internacional lhe renderá descontos em dinheiro, cujo valor pode chegar a um milhão de yuans, sem limite máximo",
    setup643: "Como é calculado o meu bónus?",
    setup644: "Após se tornar membro, a sua conta terá imediatamente uma taxa de desconto. Quanto mais utilizadores de frete logístico internacional convidar para se registar, mais bónus receberá e maior será a sua taxa de desconto. Quando o bónus atingir um determinado valor, poderá solicitar um levantamento em dinheiro ou utilizá-lo para compensar quaisquer taxas de serviço da plataforma 51Shopy. A taxa de desconto é:",
    setup645: "Como promover gratuitamente?",
    setup646: "Copie o seu link promocional ou link promocional e envie-o aos seus amigos clicando em Partilhar na página do produto. Quando visitarem e se registarem, tornar-se-ão os seus utilizadores únicos.",
    setup647: 'Hora do registo',
    setup648: 'Custos de transporte',
    setup649: 'Estado de ativação',
    setup650: 'Registo de bónus',
    setup651: 'Hora da aplicação',
    setup652: 'Recompensa total',
    setup653: 'Convidar utilizadores',
    setup654: 'Ir para a carteira',
    setup655: "Cartão de Crédito",
    setup656: "Convide os amigos para aproveitar a comissão",
    setup657:"Membro afiliado",
    setup658: "Ordem de Compra",
    setup659: "A plataforma de agentes 51Shopy suporta compras online e offline na China. Basta fornecer o link do produto e encomendar. A nossa equipa irá fornecer um serviço de primeira classe do início ao fim.",
    setup660: "Enviar para o depósito",
    setup661:"Connosco, pode comprar produtos a vários vendedores e enviá-los para o armazém da 51Shopy na China",
    setup662: "Inspeção de Qualidade",
    setup663: "Assim que os seus artigos chegarem ao armazém da 51Shopy, realizaremos uma inspeção de qualidade completa, abrangendo tudo, desde defeitos a tamanho e cor. Pode ter a certeza de que a 51Shopy oferece uma garantia fiável de serviço pós-venda.",
    setup664:"Entrega Global",
    setup665:"No armazém da 51Shopy, pode escolher e combinar produtos livremente e utilizar o serviço de logística fiável fornecido pela 51Shopy para os embalar e entregar em sua casa.",
    setup666: "Serviço completo, sem preocupações durante todo o processo",
    setup667:"Assim que os utilizadores que convidar se registarem, receberão USD:",
    setup668: "Portes grátis",
    setup669: "Não incluindo portes",
    setup670: "O envio internacional não está incluído",
    setup671:"Empresa de Logística",
    setup672: "Selecione uma empresa de logística",
    setup673: "Último número do remetente",
    setup674: "Últimos quatro dígitos",
    setup675: "Número do remetente",
    setup676:"Por favor introduza",
    setup677: "Aguarda armazenamento",
setup678: "Inclui envio internacional?",
setup679: "Sim",
setup680: "Não",
setup681: "Clique no botão 'Adicionar ao ecrã inicial'",
}
//葡萄牙